export const POPULAR_TAG = "Popular";

export const CUSTOM_TAG = "My Models";
